var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 11,
    viewBox: "0 0 10 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_839_53553)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.98201 10.073L4.69156 9.824C4.29115 9.48872 0.794922 6.46925 0.794922 4.26058C0.794922 1.94812 2.66955 0.0734863 4.98201 0.0734863C7.29447 0.0734863 9.1691 1.94812 9.1691 4.26058C9.1691 6.46927 5.67287 9.48874 5.27412 9.82565L4.98201 10.073ZM4.98201 0.978858C3.17043 0.980908 1.70236 2.44898 1.70031 4.26056C1.70031 5.6481 3.85133 7.86466 4.98201 8.87917C6.11271 7.86425 8.26371 5.64642 8.26371 4.26056C8.26166 2.44898 6.79361 0.980928 4.98201 0.978858Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.98199 5.92004C4.06535 5.92004 3.32227 5.17695 3.32227 4.26031C3.32227 3.34367 4.06535 2.60059 4.98199 2.60059C5.89863 2.60059 6.64172 3.34367 6.64172 4.26031C6.64172 5.17695 5.89865 5.92004 4.98199 5.92004ZM4.98199 3.43043C4.52367 3.43043 4.15213 3.80197 4.15213 4.26029C4.15213 4.71861 4.52367 5.09016 4.98199 5.09016C5.44031 5.09016 5.81186 4.71861 5.81186 4.26029C5.81186 3.80197 5.44033 3.43043 4.98199 3.43043Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_839_53553"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white",
    transform: "translate(0 0.0698242)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarker);
export default __webpack_public_path__ + "static/media/marker.7b934dbc9880132986b2e55019cd14dd.svg";
export { ForwardRef as ReactComponent };